// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"_2Qxm8ZHQK9ydLvG502-hR2 _3owYD3lfd6YQGGdTICLGNA","Content":"_123bR3YL0R1EOCoQhAxhvS","Buttons":"_2tNUCkvG1QEMy9_uSp-s4b"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Notifications/styles.css
// module id = 716
// module chunks = 0